import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import SupportService from '@/core/services/support.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateSupportComponent extends Vue {

  supportService: any = new SupportService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  companyList: any = [];
  message: string = "";
  subject: string = "";

  mounted (){
    const _ = this;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  create(){
    const _ = this;
    let support = {
      message: _.message,
      subject: _.subject
    };

    _.isLoading = true;
    _.supportService.create(support).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/support');
      }, 2000)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }



  validations(message = '', subject = ''){
    const _ = this;
    _.genericErr = [];
    if(message == ''){
      _.genericErr.push("Por favor escribe el mensaje");
    }
    if(subject == ''){
      _.genericErr.push("Por favor escribe el tema");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
